import axios from 'axios';

import {
  getAuthUser,
  getPermissions,
  checkForAccess,
  createFeatureAccess,
  getSessionTime,
  checkForEnvMatch,
  getCookie,
  checkRole
} from '@parkhub/parkhub-ui';

export {
  getAuthUser,
  getPermissions,
  checkForAccess,
  createFeatureAccess,
  getSessionTime,
  getCookie,
  checkRole
};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_CORE_USER_API_URL,
  withCredentials: true
});

/**
 * @param {string} [urlParams]
 */
export function signOut(urlParams = '') {
  return window.location.replace(`${process.env.REACT_APP_SUITE_URL + 'sign-out' + urlParams}`);
}

/**
 * Check if user is authenticated
 * @return {boolean} - if cookie is valid, env matches, and user has permissions true : false
 */
export const checkAuth = () => {
  const authCookie = getCookie(process.env.REACT_APP_SUITE_USER_COOKIE_NAME);
  const hasAppAccess = checkForAccess('suite.live');

  return !!authCookie && checkForEnvMatch() && hasAppAccess;
};

/**
 * @returns {Promise} request updated user and permissions cookies
 */
export function refreshSession() {
  return new Promise((resolve, reject) => {
    const cookie = getCookie(process.env.REACT_APP_SUITE_USER_COOKIE_NAME);

    if (cookie) {
      resolve(axiosInstance.post('authenticate?refreshCookie=true'));

    } else {
      reject(`Can not refresh session because current cookie expired`);
    }
  });
}

export function redirectToSignIn() {
  return window.location.replace(`${process.env.REACT_APP_SUITE_URL}signin?redirectUrl=${window.location.href}`);
}
